import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import { supabaseV2 } from "../../lib/supabase";
import { AlertBar } from "../AlertBar";

const READ_FLAG = "squad_score_notice_2026_11_read";

// Avviso una tantum sul nuovo calcolo. La lettura sta sull'account, cosi' non
// ricompare su un altro dispositivo.
export function SquadScoreNotice({ userId, className }: { userId: string; className?: string }) {
  const { t } = useTranslation("shell");
  const queryClient = useQueryClient();
  const queryKey = ["squad-score-notice-read", userId];
  const read = useQuery({
    queryKey,
    staleTime: Infinity,
    queryFn: async () => {
      const { data, error } = await supabaseV2.auth.getUser();
      if (error) throw error;
      return !!data.user?.user_metadata?.[READ_FLAG];
    },
  });
  const markRead = useMutation({
    mutationFn: async () => {
      const { error } = await supabaseV2.auth.updateUser({ data: { [READ_FLAG]: true } });
      if (error) throw error;
    },
    onMutate: () => queryClient.setQueryData(queryKey, true),
    onError: () => queryClient.setQueryData(queryKey, false),
  });
  if (read.data !== false) return null;
  return (
    <div className={className}>
      <AlertBar icon={<Info className="h-4 w-4" />} actionLabel={t("alertBars.squadScoreNotice.action")} onAction={() => markRead.mutate()}>
        {t("alertBars.squadScoreNotice.message")}
      </AlertBar>
    </div>
  );
}
